import React, {
    useEffect,
    useState,
} from 'react';

import { useNavigate } from 'react-router-dom';
import {
    useRecoilState,
    useRecoilValue,
} from 'recoil';
import {
    isAdmin,
    subMenuState,
} from 'state';
import styled from 'styled-components';
import Products from 'view/pages/Coaching/SubPage/Products';

import PlutIcon from '../../../assets/images/plus.png';
import {
    Banner,
    ContentBox,
    Contents,
    Icon,
} from '../../components';
import Requested from "./SubPage/Requested";
import Completed from "./SubPage/Completed";
import Scheduled from "./SubPage/Scheduled";
import {isEmpty} from "../../../util";


interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Live = () => {
    const navigate = useNavigate();
    const isAdminState = useRecoilValue(isAdmin);
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [popup, setOnpopup] = useState(false);

    const getSubPage = (subMenu) => {
        switch (subMenu) {
            case "Completed":{
                return <Completed/>
            }
            case "Requested":{
                return <Requested/>
            }
            case "Scheduled":{
                return <Scheduled/>
            }
        }
    };

    useEffect(() => {
        document.addEventListener("keydown",(e)=>{
            if(e.keyCode === 27){
                setOnpopup(false)
            }
        })
    }, []);

    useEffect(() => {
        if(isEmpty(subMenu)){
            setSubMenu("Requested");
        }
    }, [isAdminState]);

    return (
        <Container>
            <ContentsWrap>
                <Wrap>
                    {
                        subMenu !== "Scheduled" ?
                        <ContentBox>
                            {
                                subMenu == "Requested" &&
                                <Banner img={"/images/banner-publish.png"}
                                        url={"/images/banner-publish.png"}
                                        width={"100%"} height={220}>
                                    <BannerContents>
                                        <h2>Want to publish more classes?</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur. Pellentesque porttitor in pellentesque pellentesque nec consequat mon.
                                        </p>
                                        <Create
                                            onClick={()=>{navigate('/time_settings/manage_schedule')}}
                                        >
                                            <CreateContents>
                                                <Icon icon={PlutIcon} />
                                                <span>Manage Schedule</span>
                                            </CreateContents>
                                        </Create>
                                    </BannerContents>
                                </Banner>
                            }

                                <Contents title={subMenu === "Requested" ? "Live" : subMenu !=="Scheduled" ? subMenu : null}>
                                    {
                                        getSubPage(subMenu)
                                    }
                                </Contents>
                            </ContentBox>
                            :
                            <Scheduled/>
                    }
                </Wrap>
            </ContentsWrap>
        </Container>
    );
};
export default Live;

const Container = styled.div``;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;
`;
const Wrap = styled.div`
    width: 100%;
    //height: 100%;
    overflow-y: hidden;
    flex: 1;
    //height: calc(100vh - 100px);
    .banner{
        height: 220px!important;
    }
`;

const BannerContents = styled.div`
    width: 1048px;
    height: 100%;
    position: absolute;
    z-index: 1;
    padding: 25px 20px;
    background: linear-gradient(269.04deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 0.75) 79.51%);
    h2 {
        text-transform: uppercase;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        opacity: 0.9;
        line-height: 35.28px;
        width: 100%;
        font-family: "Source Serif 4", sans-serif;;
        @media screen and (max-width: 768px) {
            line-height: 1.2em;
            font-size: 1.2em;
        }
    }
    p {
        opacity: 0.8;
        color: #fff;
        width: 470px;
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 30px;
        font-weight: 400;
        @media screen and (max-width: 406px) {
            line-height: 1.1em;
            font-size: 1em;
        }
        @media screen and (max-width: 768px) {
            //font-size: 2.5vw;
            //font-size: 50%;

            margin-bottom: 10px;
            width: 100%;
        }
    }
`;
const Create = styled.div`
    background: #ddc160;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover{
        transform: scale(1.05);
    }
    img {
        width: 16px;
        height: 16px;
    }
`;
const CreateContents = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    span {
        line-height: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
    }
`;
